// extracted by mini-css-extract-plugin
module.exports = {"licences-table":"styles__licences-table___1JAdC","service-licence":"styles__service-licence___3MEgq","licence-name":"styles__licence-name___i_1gI"};